import { State } from 'store/state';
import { connect } from 'react-redux';
import { routeSelector } from 'store/state/selectors/router';
import { isStreetSearchLoadingSelector, filterStreetListSelector } from 'store/state/domainData/selectors';
import { StreetNearbyCarousel } from './Carousel';

const mapStateToProps = (state: State) => ({
  poi: filterStreetListSelector(state),
  isLoadingPoi: isStreetSearchLoadingSelector(state),
  route: routeSelector(state),
});

export default connect(mapStateToProps, null)(StreetNearbyCarousel);
